<template>
  <div>
    <my-notification :icon="'chain-broken'">
      <template #title>
        {{ $t('compCarbonDocsADEMEDiff.title-diff') }}
      </template>
      <ul style="list-style-type: square; margin-left: 25px">
        <li>
          {{ $t('compCarbonDocsADEMEDiff.diff-li-1-1')
          }}<strong>{{ $t('compCarbonDocsADEMEDiff.diff-li-1-str-1') }}</strong
          >{{ $t('compCarbonDocsADEMEDiff.diff-li-1-2')
          }}<strong>{{ $t('compCarbonDocsADEMEDiff.diff-li-1-str-2') }}</strong
          >{{ $t('compCarbonDocsADEMEDiff.diff-li-1-3') }}
        </li>
        <li>
          {{ $t('compCarbonDocsADEMEDiff.diff-li-2-1')
          }}<strong>{{ $t('compCarbonDocsADEMEDiff.diff-li-2-str-1') }}</strong
          >{{ $t('compCarbonDocsADEMEDiff.diff-li-2-2')
          }}<strong>{{ $t('compCarbonDocsADEMEDiff.diff-li-2-str-2') }}</strong
          >{{ $t('compCarbonDocsADEMEDiff.diff-li-2-3') }}
        </li>
        <li>
          {{ $t('compCarbonDocsADEMEDiff.diff-li-3-1')
          }}<strong>{{ $t('compCarbonDocsADEMEDiff.diff-li-3-str') }}</strong
          >{{ $t('compCarbonDocsADEMEDiff.diff-li-3-2') }}
        </li>
        <li>
          {{ $t('compCarbonDocsADEMEDiff.diff-li-4-1')
          }}<strong>{{ $t('compCarbonDocsADEMEDiff.diff-li-4-str') }}</strong
          >{{ $t('compCarbonDocsADEMEDiff.diff-li-4-2') }}
        </li>
        <li>
          {{ $t('compCarbonDocsADEMEDiff.diff-li-5-1')
          }}<strong>{{ $t('compCarbonDocsADEMEDiff.diff-li-5-str') }}</strong
          >{{ $t('compCarbonDocsADEMEDiff.diff-li-5-2') }}
        </li>
        <li>
          {{ $t('compCarbonDocsADEMEDiff.diff-li-6-1')
          }}<strong>{{ $t('compCarbonDocsADEMEDiff.diff-li-6-str') }}</strong
          >{{ $t('compCarbonDocsADEMEDiff.diff-li-6-2') }}
        </li>
      </ul>
    </my-notification>
  </div>
</template>

<script>
export default {
  name: 'ADEMEDiff',
  components: {
    'my-notification': () => import('@/components/MyNotification.vue')
  }
}
</script>

<style lang="css" scoped>
.bcteam {
  list-style-type: square;
  margin-left: 25px;
}
.bcteam > li {
  padding-top: 5px;
}
</style>
